
















import Vue from 'vue';

export default Vue.extend({
    name: 'ImageUploader',

    props: {
        label: {
            type: String,
            default: ''
        }
    },

    methods: {
        processFiles(event: Event) {
            if (event !== null && event.target !== null) {
                const files = (event.target as HTMLInputElement).files;
                if (files !== null) {
                    const file = files[0];
                    if (file.type.match('image*')) {
                        const url = URL.createObjectURL(file);
                        const image = new Image();

                        const vm = this;

                        image.onload = () => {
                            if (image.width !== image.height) {
                                alert(`Bilder måste vara kvadratiska! Denna var ${image.width}x${image.height}.`);
                                return;
                            }
                            const formData = new FormData();
                            formData.append('image', file);
                            formData.append('width', image.width.toString());
                            formData.append('height', image.height.toString());
                            vm.$emit('upload-form-data', formData);
                            URL.revokeObjectURL(url);
                        };

                        image.src = url;
                    } else {
                        alert('That was not an image, it was ' + file.type);
                    }
                }
            }
        }
    }
});
